import React, { useState } from 'react'
import { gql, useMutation } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import Loader from '../components/loader'
import { PageBody } from '../components/page-body'

import * as ga from '../lib/ga'

import styles from '../styles/page.module.css'
import stylesLogin from './login.module.css'
import stylesForm from '../components/form.module.css'

const REQUEST_RESET_PASSWORD = gql`
  mutation RequestPasswordReset($email: String!) {
    appRequestPasswordReset(email: $email)
  }
`

function RequestPasswordResetPage() {
  const [errorName, setErrorName] = useState(null)
  const { t } = useTranslation('forgotPassword')

  let email
  const [appRequestPasswordReset, { data: resetData, loading: resetLoading }] =
    useMutation(REQUEST_RESET_PASSWORD, {
      onError(err) {
        const error = `${err}`.split(':').reverse()[0]
        setErrorName(error)
      }
    })

  if (resetLoading) {
    return <Loader />
  }

  if (resetData) {
    return (
      <>
        <h1 className={styles.title}>
          <span className={stylesLogin.titleThin}>{t('title')}</span>
        </h1>
        <p style={{ textAlign: 'center' }}>
          {t('linkSent')}
          <br />
          {t('linkSentClick')}
        </p>
      </>
    )
  }

  return (
    <PageBody>
      <h1 className={styles.title}>
        <span className={stylesLogin.titleThin}>{t('title')}</span>
      </h1>

      <form
        className={stylesForm.form}
        onSubmit={(e) => {
          e.preventDefault()
          appRequestPasswordReset({
            variables: { email: email.value }
          })
          email.value = ''
          setErrorName(null)

          ga.event({
            action: 'request_password_reset'
          })
        }}
      >
        <div className={stylesForm.inputrow}>
          <label htmlFor="email" className={stylesForm.label}>
            {t('content:email')}
          </label>
          <input
            id="email"
            type="email"
            className={stylesForm.input}
            ref={(node) => {
              email = node
            }}
          />
        </div>

        <div className={stylesForm.submitBtnWrap}>
          <button type="submit" className={`btn ${stylesForm.submitBtn}`}>
            {t('btnResetPassword')}
          </button>
        </div>

        {errorName && (
          <div style={{ textAlign: 'center', color: 'red', padding: '10px' }}>
            {errorName}
          </div>
        )}
      </form>
    </PageBody>
  )
}

export default RequestPasswordResetPage
